import React from "react";
import SimpleBarReact from "simplebar-react";

import "./App.css";
import Routers from "./routes/Router.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
function App() {
  return (
    <div className=" overflow-x-hidden bg-black">
      <Routers />
      <ToastContainer />
    </div>
  );
}

export default App;
